export default __webpack_public_path__ + "static/media/apple_W.105808cd.png";